module.exports = __webpack_public_path__ + "static/img/ind_ban_06.76b6495c.jpeg";